import { Entity } from '@core/api/entity';
import { Field, Model } from '@junte/serialize-ts';

@Model()
export class DataroomNodeChangeAuthor extends Entity {
  @Field()
  public fullName: string;
}
